<template>
    <div class="price-specification">
        <PriceSpecificationRow
            :price="totalPrice"
            class="total"
            :description="t({ key: 'shared.total_price' })" />
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, PropType } from 'vue';
    import { FerryProduct } from '@/api/Cart/cart.interfaces';
    import { mapFerryPrice } from '../../PriceBreakdown/map/ferry';
    import { t } from '@shared/helpers/translation';

    import PriceSpecificationRow from '../PriceSpecificationRow.vue';

    export default defineComponent({
        name: 'PriceSpecificationFerry',
        methods: { t },
        components: {
            PriceSpecificationRow,
        },
        props: {
            product: {
                type: Object as PropType<FerryProduct>,
                required: true,
            },
        },
        setup({ product }) {
            const totalPrice = computed(() => mapFerryPrice(product));
            return {
                totalPrice,
            };
        },
    });
</script>

<style lang="scss">
    @forward '@/components/shared/PriceSpecification/PriceSpecification';
</style>
